import styled from 'styled-components';

interface iError {
  error?: boolean;
}

export const Container = styled.span<iError>`
  display: flex;
  align-items: center;
  width: 100%;
  height: 40px;
  border: 1px solid ${props => (props.error ? 'red' : '#b4b7b9')};
  border-radius: 6px;
  padding: 12px 16px 12px 12px;

  #date-picker-inline-helper-text {
    display: none;
  }
`;

export const ContainerRoot = styled.div<iError>`
  width: 100%;

  h5 {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    color: ${props => (props.error ? 'red' : '#444a51')};
    margin-bottom: 4px;
  }

  #error {
    color: red;
  }
`;

export const Label = styled.span`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: #444a51;
  margin-bottom: 4px;
`;
